import React from "react";
import "./Footer.css";
import ScrollService from "../../Utilities/ScrollService";
export default function Footer() {
  return (
    <div className="scroll-container">
      <button
        className="btn-scroll"
        onClick={() => ScrollService.scrollHandler.scrollToHome()}
      > <a href="#top"> {" "}
      <i className="fa fa-arrow-up"></i></a>
       
      </button>
    </div>
  );
}